module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsHDAwHwABI5AAAANJJREFUSMft1jFOhFAUQNEzSNgG4xZsNdGKjUDcgEYrYdZhwgZ0C8Sx0EbHwsTagl0MjRYDhsYOqP5NXvHzk3eTV10OxLjFB/b4mWj22PW7YyPZ84SS/2aLOMY1ztM0Vde1701lSo6rjTzPtW17gatVf8aTpmkmlw2sy0qWZbBb9XdO7s9Ozcnlyyt0ERLLkUQWJgiDMAiDMAiDMAgPwm5BXxfha6iruViXf3H2GeEBiqIYf0xGelcqimJ4Pg4hvF0ghJ9wNK7vG7zPkPpv/e4YfgEnyoLUdnIvzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_secciones.png
// module id = NxbV
// module chunks = 0